export class Storage {
  constructor() {}

  /**
   * @desc Sets item in local storage
   * @param {*} key
   * @param {*} value
   */
  setStorage(key, value) {
    // btoa only accepts one-byte characters and throws for Unicode such as "•" or "–".
    // encodeURIComponent converts Unicode to UTF-8 percent-encoded bytes, and unescape
    // turns those bytes into the binary string btoa expects. This lets values such as
    // "café" be stored without losing or corrupting characters.
    localStorage.setItem(key, btoa(unescape(encodeURIComponent(value))));
  }

  /**
   * @desc Fetch's items from local storage
   * @param {*} key
   * @returns string
   */
  getStorage(key) {
    const value = localStorage.getItem(key);
    if (value) {
      const decoded = atob(value);
      try {
        // Reverse the conversion above so UTF-8 bytes such as C3 A9 become "é" again.
        // escape also protects literal percent sequences: "a%20b" remains "a%20b"
        // instead of decodeURIComponent interpreting it as "a b".
        // Older entries were written directly with btoa(value), so they may not contain
        // valid UTF-8. In that case, the URIError fallback returns the legacy value unchanged.
        return decodeURIComponent(escape(decoded));
      } catch (error) {
        if (error instanceof URIError) {
          return decoded;
        }
        throw error;
      }
    }
    return null;
  }

  /**
   * @param {string} key
   * @desc Clear individual item but not the entire storage
   */
  clearItem(key) {
    localStorage.removeItem(key);
  }

  /**
   * @desc Clear's storage
   */
  clearStorage() {
    localStorage.clear();
  }
}
